import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './ListItem.module.css'
import { Button, Divider, Flex, message, Tag, Tooltip } from 'antd'
import classNames from 'classnames'
import pointIcon from './point.svg'
import { downloadFileRequest } from '../ResourceLibApi'
import { getSixMathRandom } from '../../../../util/handMath'
import Cookies from 'js-cookie'
export default function ListItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function downLoadFile(e) {
    let timestamp = new Date().getTime()
    let random = getSixMathRandom()
    let jilu_code = timestamp + random+Cookies.get("username")
    console.log(props.info)
    downloadFileRequest(props.info.code, jilu_code, (data) => {
      if (data.ret == 1) {
        console.log(data)
        // window.open(data.data.ziyuan_url)
        const a = document.createElement('a');
        a.href = data.data.ziyuan_url;
        // a.download = props.currentResource.name+'.pdf';
        // 第二步：触发下载
        a.click();
        let tempResource = {...props.info}
        tempResource.xiazai_num = parseInt(tempResource.xiazai_num) + 1
        props.setCurrentResource(tempResource)
        message.success('下载成功')
      } else {
        message.warning(data.msg)
      }
    })
  }
  return (
    <div className={styles.card}>
      <div className={styles.banner}>
        <img
          src={
            props.info.fengmian_url
          }
          className={styles.bannerImg}
        />

        {/* <span className={styles.subjectTag}>数学</span> */}
        {props.info.hasOwnProperty('nianjiList') && (
          <div className={styles.subjectTag}>
            {props.info.nianjiList.map((item, index) => {
              return (
                <Tag
                  color={item.color}
                  variant={'solid'}
                  style={{ marginTop: 0,zIndex:1000 }}
                >{item.label}</Tag>
              )
            })}
            {props.info.xuekeList.map((item, index) => {
              return (
                <Tag
                  color={item.color}
                  variant={'solid'}
                  style={{ marginTop: 10,zIndex:1000 }}
                >{item.label}</Tag>
              )
            })}
          </div>
        )}
        <span className={styles.sizeTag}>{props.info.size}MB</span>
      </div>

      {/* 下半部分：信息区域 */}
      <div className={styles.infoArea}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>{props.info.title}</h3>
          {props.info.xiangqing_url==""||props.info.xiangqing_url=="null"?null:
          <a href={props.info.xiangqing_url} target='_blank' className={styles.quickLink}>
            快速了解
          </a>
        }
        </div>
        <p className={styles.desc}>适用: 
          {props.info.nianjiList.map((item, index) => {
            return (
              <span key={index}>{item.label}</span>
            )
          })}
        </p>
        {/* <p className={styles.fileInfo}>10个文件</p> */}
        <p className={styles.downloadInfo}>{props.info.xiazai_num}次下载</p>
        <div className={styles.actionRow}>
          <span className={styles.credit}>
            <img src={pointIcon} className={styles.coinIcon} /> {props.info.jifen}积分
          </span>
          <div className={styles.buttonContainer}>
            <Button type="default" className={styles.detailBtn} onClick={(e)=>{
              props.openDetailModal(props.info)
            }}>
              详情
            </Button>
            <Button type="primary" className={styles.downloadBtn}
              onClick={downLoadFile}
            >
              下载
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

